import { OnDemandAutoUploadNode } from "./MedicinalProductsNode/OnDemandAutoUploadNode";
import { SimpleSearchListNode } from "./SimpleSearchListNode";

export class OnDemandSimpleSearchListNode extends SimpleSearchListNode {
    getOnDemandEntities(): any[]{
        let onDemandEntities: any[] = [];
        this.children?.forEach(child => {
            if (child instanceof OnDemandAutoUploadNode) {
                const onDemandNode = child.getOnDemandEntities();
                if (Array.isArray(onDemandNode ) || Object.keys(onDemandNode ).length !== 0) {
                    onDemandEntities.push(onDemandNode);  
                }
            }
            
        });
        return onDemandEntities;
    }

    override refreshLabel(): void {
        this.label = this.parent instanceof OnDemandAutoUploadNode ? `${this.labelTemplate} (${this.children?.length ?? 0})` : this.labelTemplate;
    }

}